

import React from "react";
import worldBook from "../Images/worldBook.jpg";
import lavishLook from "../Images/lavishLook.jpg";
import monday from "../Images/monday.jpg";
import fitfactory from "../Images/fitfactory.jpg";
import eyekart from "../Images/eyekart.jpg";
import travieApp from "../Images/traviez_app.png";
import travieWeb from "../Images/traviez_web.png";
import { Badge, Button, Heading, Text } from "@chakra-ui/react";
import "./project.css";
import { Link } from "react-router-dom";
let data = [
  {
    id: 0,
    name: "Traviez App",
    img: travieApp,
    link: "https://play.google.com/store/search?q=traviez&c=apps&hl=en",
    // git: "https://github.com/Sachin-Kesarwani/smooth-cracker-7739",
    description: "Explore Varanasi’s Hidden Gems with Traviez Local Traviez Local is here to bring you the most authentic shopping experience in the spiritual heart of India.",
    tech: ["React Native ","JavaScript "  , "Tailwind CSS"],
  },
  {
    id: 1,
    name: "Traviez web",
    img: travieWeb,
    link: "https://www.traviez.com/",
    // git: "https://github.com/Sachin-Kesarwani/smooth-cracker-7739",
    description: "I developed a seamless Traviez platform integrating transport, stay, and destination details, and designed a user-friendly Business & Marketing Dashboard to enhance engagement and operational efficiency.",
    tech: ["Next JS ","JavaScript "  , "Tailwind CSS"],
  },
  
  {
    id: 2,
    name: "World Book",
    img: worldBook,
    link: "https://poetic-griffin-07f79c.netlify.app/",
    git: "https://github.com/Sachin-Kesarwani/smooth-cracker-7739",
    description:
      "This website generally for to buy books , the main reason behind to built this website is make students life easy and relaxe . ",
    tech: ["HTML ", "CSS ", "JavaScript "],
  },
  {
    id: 3,
    name: "Lavish Look",
    img: lavishLook,
    link: "https://lavish-look-sachin-kesarwani.vercel.app/",
    git: "https://github.com/Sachin-Kesarwani/pushy-dime-8312",
    description:
      "This is E-commerce websit where you can buy clothes , shoes and products for kids . In this website there are many types product for both mens , womens and for childrens.",
    tech: ["REACT", "Chakra UI", "Bootstrap"],
  },
  {
    id: 4,
    name: "monday.com",
    img: monday,
    link: "https://lovely-snickerdoodle-8bb2d5.netlify.app/",
    git: "https://github.com/lokeshchoudharyprogrammer/superficial-point-8316",
    tech: ["HTML", "CSS", "JavaScript"],
    description:
      "This is a collaborative which is cloned by 5 developers . Basically This website is just for to make team ,assign member for team .",
  },
  {
    id: 5,
    name: "Fit-Factory",
    img: fitfactory,
    link: "https://fit-factory.vercel.app/",
    git: "https://github.com/Sachin-Kesarwani/detailed-hour-2985",
    tech: ["React", "Chakra UI", "Redux", "JSON Server" ],
    description:
      "This is a collaborative which is cloned by 3 developers . Basically This is the Indias No 1website where we sell health realted products .",
  },
  {
    id: 6,
    name: "Eyekart",
    img: eyekart,
    link: "https://eyekart-sachin-kesarwani.vercel.app/",
    git: "https://github.com/Sachin-Kesarwani/omniscient-dust-8885",
    tech: ["React", "Chakra UI", "Redux","Node JS","Express JS","Mongo DB"],
    description:
      "This is a collaborative which is cloned by 5 developers . Basically This is the Indias No 1 website of eyewear and sunglasses .",
  }
];
const Project = () => {
  return (
    <div style={{ paddingTop: "120px" }}>
      <Heading margin={"20px"} color={"white"}>
        My Projects
      </Heading>
      <div id="projects">
        {/* <div id="projectmaindiv"  > */}
        {data.map((e, i) => {
          return (
            <div
              key={i}
              style={{
                borderRadius: "10px",
                backgroundColor: "black",
                border: "1px solid #2e9b56",
              }}
              className="project-card"
            >
              <div id="projectimageDiv" style={{ height: "40%" }}>
                <Heading as={"h4"} color={"#2e9b56"} className="project-title">
                  {e.name}
                </Heading>
                <img id="projectimage" src={e.img} />
              </div>
              <div className="project-tech-stack" style={{marginTop:"10px"}} >
                <Text    textAlign={"justify"} display={{display:"flex",justifyContent:"spaceEvenly,"}}>
                  <Badge bg="green.700" color={"white"}>
                    Tech Stacks
                 </Badge>
                  {e.tech.map((a,i) => (
                <div style={{display:"inline",padding:"0px"}}>
                     <Badge
                      margin={"0px 3px"}
                      variant="solid"
                      colorScheme="black"
                    >
                   <b>{a}</b> 
                    
                    </Badge><span style={{color:"white"}}>{i!=e.tech.length-1?`|`:``}</span></div>  
                  ))}
                </Text>
              </div>
              {/* <hr style={{border:"1px solid black"}}></hr> */}
              <div style={{ padding: "8px", height: "23%",marginBottom:"3px" }}>
                <Text
                  color="white"
                  textAlign={"justify"}
                  className="project-description"
                >
                  {e.description}
                </Text>
              </div>

              {/* <hr style={{border:"1px solid black"}}></hr> */}
              {/* <div className="project-tech-stack" >
                <Text    textAlign={"justify"} display={{display:"flex",justifyContent:"spaceEvenly"}}>
                  <Badge bg="green.700" color={"white"}>
                    Tech Stacks
                 </Badge>
                  {e.tech.map((a,i) => (
                <div style={{display:"inline",padding:"0px"}}>
                     <Badge
                      margin={"0px 3px"}
                      variant="solid"
                      colorScheme="black"
                    >
                    {a}
                    
                    </Badge><span style={{color:"white"}}>{i!=e.tech.length-1?`|`:``}</span></div>  
                  ))}
                </Text>
              </div> */}
              {/* <hr style={{border:"1px solid black"}}></hr> */}
              <div style={{height:"28%",marginTop:"8%"}}>
                <Button
                     boxShadow= "0 0 3px 3px rgba(0, 255, 0, 0.5)"
                  position="static"
                  className="project-deployed-link"
                  bg="black"
                  _hover={{ bg: "#2e9b56", color: "white" }}
                  color="#2e9b56"
                  border={"2px solid #2e9b56"}
                  marginRight={3}
                >
                  <a href={e.link} target="_blank">
                    Live
                  </a>
                </Button>
              { e.git && <Button
                     boxShadow= "0 0 3px 3px rgba(0, 255, 0, 0.5)"
                  position="static"
                  className="project-github-link"
                  bg="black"
                  _hover={{ bg: "#2e9b56", color: "white" }}
                  color="#2e9b56"
                  border={"2px solid #2e9b56"}
                >
                  <a href={e.git} target="_blank">
                    Github
                  </a>
                </Button>}
              </div>
            </div>
          );
        })}
        {/* </div> */}
      </div>
    </div>
  );
};

export default Project;
